import { Inject, Injectable, Injector } from '@angular/core';



@Injectable({ providedIn: 'root' })
export class Carriers_ReportService {

  constructor(
    private injector: Injector
  ) {
  }

  public Carriers: Carriers_ReportService = this;

  // injecting lazily in order to avoid circular dependencies
}

